import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onPageLoadSuccess = (page) => {
    if (!pageWidth) {
      const viewport = page.getViewport({ scale: 1 });
      setPageWidth(viewport.width + 10);
    }
  };

  // ✅ ResizeObserver for dynamic width detection
  useEffect(() => {
  const observer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const width = entry.contentRect.width;
      // ✅ Schedule update safely
      requestAnimationFrame(() => setContainerWidth(width));
    }
  });

  const el = containerRef.current;
  if (el) observer.observe(el);

  return () => {
    if (el) observer.unobserve(el);
  };
}, []);

  const scale = pageWidth ? containerWidth / pageWidth : 1;

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <div key={`page_${index}`} style={{ display: 'flex', justifyContent: 'center' }}>
            <Page
              pageNumber={index + 1}
              scale={scale}
              onLoadSuccess={index === 0 ? onPageLoadSuccess : undefined}
              renderMode="canvas"
            />
          </div>
        ))}
      </Document>
    </div>
  );
};

export default PDFViewer;
